export default __webpack_public_path__ + "static/media/read.71d86009.png";